module.exports = __webpack_public_path__ + "img/no-module.8de5c4be.jpg";